import React from 'react';
import logo from '../../assets/logo1.png'; 
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center text-center md:text-left space-y-8 md:space-y-0">

          {/* Logo */}
          <div className="flex flex-col items-center md:items-start">
            <img src={logo} alt="Butterfly Groups Logo" className="h-24 md:h-28" />
          </div>

          {/* Navigation + Socials */}
          <div className="flex flex-col items-center space-y-6">
            <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 text-gray-700 font-medium">
              <li><a href="/#" className="hover:text-blue-600 transition">Home</a></li>
              <li><a href="/about" className="hover:text-blue-600 transition">About Us</a></li>
              <li><a href="/wellness" className="hover:text-blue-600 transition">Wellness</a></li>
              <li><a href="https://butterflyhrglobal.com/job-vacancies" className="hover:text-blue-600 transition">Careers</a></li>
              <li><a href="/contact" className="hover:text-blue-600 transition">Contact Us</a></li>
            </ul>

            {/* Social Media Icons */}
            <div className="flex space-x-6 justify-center">
              <a href="https://www.facebook.com/people/Butterfly-Consulting-Training/100087045468384/"><FaFacebookF className="text-blue-600 text-xl hover:scale-110 transition" /></a>
              <a href="https://x.com/butterflyhr1"><FaXTwitter className="text-black-400 text-xl hover:scale-110 transition" /></a>
              <a href="https://www.instagram.com/butterflyconsulting.training/"><FaInstagram className="text-pink-500 text-xl hover:scale-110 transition" /></a>
              <a href="https://www.youtube.com/@ButterflyGroups"><FaYoutube className="text-red-500 text-xl hover:scale-110 transition" /></a>
              <a href="https://www.linkedin.com/company/butterfly-consulting-training/"><FaLinkedinIn className="text-blue-700 text-xl hover:scale-110 transition" /></a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-sm text-gray-500 text-center md:text-right">
            © 2025 ButterflyGroup — All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
